import { Injectable } from '@angular/core';
import { Span, SpanOptions } from '@opentelemetry/api';
import { MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { PerformanceService } from './performance-service';
import { NoopSpan } from './noop-span';
import { ObservabilityService } from './observability-service';

type SuggestionServiceName = 'algolia' | 'data-index';

@Injectable({
  providedIn: 'root',
})
export class SuggestionObservabilityService {
  private span: Span = new NoopSpan();

  constructor(
    private observabilityService: ObservabilityService,
    private metaTagsService: MetaTagsService,
    private performanceService: PerformanceService
  ) {}

  public logRequestDurations(promise: Promise<any>, suggestionServiceName: SuggestionServiceName) {
    const onFinish = (response: any) => {
      this.performanceService.getEntriesByType('resource').forEach((entry) => {
        if (entry.name.includes('algolia.net')) {
          this.createSpan(entry, suggestionServiceName);
        }
      });

      return response;
    };

    return promise.then(onFinish).catch(onFinish);
  }

  private createSpan(entry: PerformanceEntry, suggestionServiceName: SuggestionServiceName) {
    const options: SpanOptions = {
      startTime: entry.startTime,
      attributes: {
        'mode.webapp_ui.algolia_request_url': entry.name,
        'mode.webapp_ui.algolia_request_duration': entry.duration,
        'mode.webapp_ui.user_name': this.metaTagsService.getTag(MetaTags.CurrentUsername) || '',
        'mode.webapp_ui.org_name': this.metaTagsService.getTag(MetaTags.OwnerUsername) || '',
      },
    };
    this.span = this.observabilityService.startTrace(`${suggestionServiceName}-request`, options);
    this.span.end(entry.startTime + entry.duration);
  }
}
